<!--
@作者 王
@创建于 2021/3/1 21:25
-->

<template>
    <div>
        <el-dialog
                :title="title"
                top="5vh"
                :visible.sync="dialogVisible" :width="width">
            <table class="lj-view-table">
                <template v-for="(item,index) in tableData">
                <tr>
                    <template v-for="data in item">
                        <template v-if="!data.type || data.type !== 'Array'">
                        <td class="label">
                            {{data.label}}
                        </td>
                        <td :colspan="data.line?(lineItems*2-1) : 1">
                            <span v-if="!data.type || data.type !== 'slot'">
                                <view-image-page :att-guids="data.value" v-if="data.img"></view-image-page>
                                <span v-else-if="data.select && !Array.isArray(data.value)">
                                    {{data.options.find(i=>i.value === data.value)?data.options.find(i=>i.value === data.value).label:(data.value&&data.value.text?data.value.text:'')}}
                                </span>
                                <span v-else-if="data.select && Array.isArray(data.value)">
                                    <el-tag size="mini" v-for="(ii,index2) in data.value" :key="index2" style="margin: 2px">
                                    {{data.options.find(i=>i.value === ii)?data.options.find(i=>i.value === ii).label:ii}}</el-tag>
                                </span>
                                <span v-else-if="typeof data.value === 'object'">
                                    {{data.value?data.value.text:data.value}}
                                </span>
                                <span v-else-if="data.label === '身份证号'">
                                    {{data.value.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2")}}
                                </span>
                                <span v-else>
                                    {{data.value | filterBoolean}}
                                </span>
                            </span>
                            <slot v-else :name="data.prop"></slot>
                        </td>
                        </template>
                    </template>
                </tr>
                </template>
                <slot name="tableView"  :tableData="tableData"></slot>
            </table>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "lj-view-dialog",
        props:{
          title:{
              default:'查看'
          },
            width:{
              default: '50%'
            },
            /**
             * 字典项
             * 示例
             * {
             *     name:'姓名',
             *     age:{
             *         label:'年龄', // 中文
             *         prop:'age',   // key键值
             *         slot:false,   // 是否插槽模式
             *         line:true     // 是否整行
             *     }
             * }
             **/
            dictionary:{

            },
            lineItems:{
              default:2
            }
        },
        data(){
            return{
                dialogVisible:false,
                tableData:[]
            }
        },
        filters:{
            filterBoolean(value){
                if (typeof value === 'boolean'){
                    return value ? '是':'否'
                }else {
                    return  value
                }
            }
        },
        methods:{
            show(data){
                this.tableData = [];
                let arr = [];
                for(let key in this.dictionary){
                    // 简易模式
                    if (typeof this.dictionary[key] === 'string' ){
                        arr.push({
                            label:this.dictionary[key],
                            value:data[key]
                        });
                        if (arr.length === this.lineItems ){
                            this.tableData.push(arr);
                            arr = []
                        }
                        if (key === (Object.keys(this.dictionary)[Object.keys(this.dictionary).length - 1])){
                            this.tableData.push(arr);
                            arr = []
                        }
                    }else{
                        // 占整行
                        if (this.dictionary[key].line){
                            if (arr.length>0){
                                arr[0]["line"] = true;
                                this.tableData.push(arr);
                                arr = []
                            }
                            this.tableData.push([{
                                ...this.dictionary[key],
                                value:data[key]
                            }]);
                        }else{
                            // 复杂模式
                            if (key.indexOf('.')>-1){
                                arr.push({
                                    ...this.dictionary[key],
                                    value:data[key[0]][key[1]][key[2]]
                                });
                            }else{
                                arr.push({
                                    ...this.dictionary[key],
                                    value:data[key]
                                });
                            }
                            if (arr.length === this.lineItems || key === (Object.keys(this.dictionary)[Object.keys(this.dictionary).length - 1])){
                                this.tableData.push(arr);
                                arr = []
                            }
                        }
                    }
                }
                this.dialogVisible = true;

            }
        }
    }
</script>

<style lang="less">
    .lj-view-table{
        table-layout:auto;
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #e8e8e8;
        tr{
            border-bottom: 1px solid #e8e8e8;
        }
        td{
            padding: 16px 24px;
            border-right: 1px solid #e8e8e8;
            color: rgba(0,0,0,.85);
            font-weight: 400;
            width: 25%;
            font-size: 14px;
            line-height: 1.5;
        }
        .label{
            background-color: #fafafa;
        }
      /deep/ .el-image-viewer__wrapper{
        z-index: 2010!important;
      }
    }
</style>
